<template>
  <OneCol
    slideColor="black"
    :backgroundImage="$store.state.width > 767 ? question.backgroundImage : question.backgroundImageMob"
    maxWidth="800px"
    :borderRadius="0"
    :titleEnd="true"
  >
    <template v-slot:title>
      <div class="full_left">
        <div class="big_title">
          <h1
            v-if="question.id == 1"
            :style="{ marginTop: $store.state.width < 768 ? '40px' : '0'}"
            v-html="$store.state.copy.header.title"
          >
          </h1>
        </div>

        <div class="subtitle_wrap">        
          <h2
            v-if="question.id == 1"
            v-html="$store.state.copy.header.subtitle"
          ></h2>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div class="question_wrap">
        <div class="number_wrap">
          <h3>{{ question.id }} of {{ $store.state.questions.length }}</h3>
        </div>
        <div
          class="question_left"
          :class="{ narrow: typeof(question.answers[0]) == 'object' || question.type === 'wide' }"
        >
          <p class="question_text" v-html="question.question"></p>
        </div>
        <div
          class="question_right"
          :class="{ wide: question.type === 'wide' }"
          v-if="typeof(question.answers[0]) != 'object'"
        >
          <GenericButton
            v-for="(answer, i) in question.answers"
            :key="i"
            @click="answerQuestion(question.id-1, i)"
            :text="answer"
            :height="0"
          ></GenericButton>
        </div>
        <div class="question_right image" v-if="typeof(question.answers[0]) == 'object'">
          <button
            class
            v-for="(answer, i) in question.answers"
            :key="i"
            @click="answerQuestion(question.id-1, i)"
          >
            <img :src="answer.img" :alt="answer.text" />
            <span>{{ answer.text }}</span>
          </button>
        </div>
      </div>
    </template>
  </OneCol>
</template>

<script>
import OneCol from "../components/template/OneCol";

import GenericButton from "../components/generic/GenericButton";
export default {
  name: "Question",
  props: ["question"],
  components: {
    OneCol,
    GenericButton
  },
  methods: {
    answerQuestion(question, answer) {
      this.$store.commit("answerQuestion", {
        question,
        answer
      });
      this.analytics("question_" + (question + 1), "answer_" + (answer + 1));
      if (question + 1 == this.$store.state.questions.length) {
        if (this.$store.state.supporter) {
          this.gotoSlide("shareAsk");
        } else {
          this.gotoSlide("signAsk");
        }
      } else {
        this.gotoSlide("question_" + (question + 2));
      }
    }
  }
};
</script>
<style lang="scss" scoped>
h2 {
  @media (max-width: 767px) {
    font-size: 20px !important;
  }
}
.big_title {
  padding-bottom: 12px;
  @media (max-width: 767px) {
    padding: 12px;
  }
}

.subtitle_wrap {
  width: 100%;
}

.image_helper {
  @media (max-width: 767px) {
    display: none;
  }
  margin-bottom: 15px;
  img {
    width: 100%;
    height: auto;
  }
}
.question_wrap {
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 767px) {
    flex-direction: column;
  }

  .image_helper_mob {
    @media (min-width: 768px) {
      display: none;
    }
    margin-bottom: 7px;
    img {
      width: 100%;
      height: auto;
    }
  }

  .number_wrap {
    width: 100%;
    padding-bottom: 20px;
    @media (max-width: 767px) {
      padding-bottom: 0;
    }
    h3 {
      font-family: "AmnestyTradeGothic";
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: white;
      background: black;
      display: inline-block;
      padding: 10px 15px;
      line-height: 1;
      margin-bottom: 10px;
      text-transform: uppercase;
      @media (max-width: 767px) {
        font-size: 22px;
        padding: 7px 10px;
      }
    }
  }

  .question_left {
    width: 50%;
    font-size: 23px;
    // font-weight: bold;
    line-height: 1.4;
    padding-right: 30px;
    font-family: "AmnestyTradeGothic";

    &.narrow {
      width: 40%;
      @media (max-width: 767px) {
        width: 100%;
      }
    }

    @media (max-width: 767px) {
      width: 100%;
      font-size: 20px;
      line-height: 1.3;
      padding-right: 0;
      padding-bottom: 15px;
    }
  }
  .question_right {
    width: 50%;
    display: flex;
    flex-direction: column;
    @media (max-width: 767px) {
      width: 100%;
    }
    button {
      margin-bottom: 14px;
      @media (max-width: 767px) {
        font-size: 22px !important;
      }
    }
    &.wide {
      width: 60%;
      @media (max-width: 767px) {
        width: 100%;
      }
    }
    &.image {
      width: 60%;
      flex-direction: row;
      flex-wrap: wrap;
      button {
        padding: 0;
        border: 0;
        background: #fc0081;
        font-family: "AmnestyTradeGothic";
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.55px;
        text-align: center;
        color: #ffffff;
        width: calc(50% - 7px);
        margin-right: 14px;
        cursor: pointer;
        transition: 0.25s;

        &:hover {
          background: #5bb700;
        }

        &:nth-of-type(2n) {
          margin-right: 0;
        }
        img {
          display: block;
          width: 100%;
        }
        span {
          padding: 8px 0;
          display: block;
        }

        @media (max-width: 767px) {
          &:nth-of-type(3),
          &:nth-of-type(4) {
            margin-bottom: 0;
          }
        }
      }
      @media (max-width: 767px) {
        width: 100%;
      }
    }
  }
}
</style>